import { render, staticRenderFns } from "./lp-campaign-for-investors-ii.vue?vue&type=template&id=152b6e9c&scoped=true"
import script from "./lp-campaign-for-investors-ii.vue?vue&type=script&lang=js"
export * from "./lp-campaign-for-investors-ii.vue?vue&type=script&lang=js"
import style0 from "./lp-campaign-for-investors-ii.vue?vue&type=style&index=0&id=152b6e9c&prod&scoped=true&lang=css"
import style1 from "./lp-campaign-for-investors-ii.vue?vue&type=style&index=1&id=152b6e9c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b6e9c",
  null
  
)

export default component.exports